export interface RouteStop {
  id: string;
  placeName: string;
  isOptional: boolean;
}

export interface CreateRouteStop {
  id: string;
  placeName: string | number;
  travelTime: string;
  duration: string; // Duration of stay in hours
  transportType: string; // Car, Bus, Walk, Flights, Boat
  isOptional: boolean;
  selectedPlace?: string;
  stopTravelTime?: string | number;
  stopDuration?: string | number;
  stopTransportType?: string | number;
  isStopOptional?: string | number;
}

export interface ZiyaratRoute {
  id: string;
  routeName: string;
  venue: string;
  travelTime: string; // in hours
  bufferTime: string; // in hours
  isTransportRequired: boolean;
  isOptional: boolean;
  isActive: boolean;
  stops: RouteStop[];
}

export type Ziyarat = {
  code: string;
  name: string;
  isActive: boolean;
  publicId: string;
  venueId: number;
  venueName: string;
};

export type AddZiyaratPayload = {
  name: string;
  code: string;
  venueId: number;
  isActive: boolean;
};

export type UpdateZiyaratPayload = {
  publicId: string;
  name: string;
  code: string;
  venueId: number;
  isActive: boolean;
};

export type Venue = {
  id: number;
  ziyaratId: number;
  name: string;
  venueId: number;
  venueName: string;
};

export interface ReceiptDetail {
  currencyCode: string;
  unitRate: number;
  units: number;
  roundoff: number;
  isSelected: boolean;
}

export interface ZiyaratFilters {
  pageNo?: number;
  pageSize?: number;
  searchTerm?: string;
  placeName?: string;
  venue?: string;
  status?: string;
  routeName?: string;
  transport?: string;
  optionalRoute?: string;
  lawazimRequired?: string;
  type?: string;
}

export interface AtraafDetailPayload {
  ziyaratId: number;
  travelTimeMinutes?: string;
  durationHours?: string;
  transportType: string;
  optionalFlag: boolean;
}

export interface AtraafStopResponse {
  ziyaratId: number;
  ziyaratName: string;
  travelTimeMinutes: string;
  durationHours: string;
  transportType: string;
  optionalFlag: boolean;
}

export type LawazimPolicy = 0 | 1 | 2;

export const normalizeLawazimPolicy = (value: unknown): LawazimPolicy => {
  if (value === 2 || value === "2") return 2;
  if (value === 1 || value === "1" || value === true || value === "true" || value === "yes" || value === "required") return 1;
  return 0;
};

export interface AtraafSlotPayload {
  slotName: string;
  startTime: string;
  capacity: number;
  isActive: boolean;
  slotId?: number;
}

export interface AddAtraafPayload {
  publicId?: string | number;
  venueId: number;
  atraafName: string;
  minDays: number;
  sortPriority: number;
  capacity: number;
  availableDays: string;
  durationHours: string;
  transportRequired: boolean;
  optionalRoute: boolean;
  lawazimPolicy: LawazimPolicy;
  isActive: boolean;
  details: AtraafDetailPayload[];
  slots: AtraafSlotPayload[];
}

export interface AtraafStop {
  ziyaratId: number;
  travelTimeMinutes: string;
  durationHours: string;
  transportType: string;
  optionalFlag: boolean;
}

export interface AtraafItem {
  id: number;
  publicId: string;
  venueId: number;
  venueName: string;
  atraafName: string;
  capacity?: number;
  minDays: number;
  sortPriority: number;
  availableDays: string;
  canBeDoneMultipleTimes: boolean;
  includeDaily: boolean;
  durationHours: string;
  transportRequired: boolean;
  optionalRoute: boolean;
  lawazimPolicy?: LawazimPolicy;
  lawazimRequired?: boolean | "yes" | "no" | "required";
  isActive: boolean;
  detailsCount: number;
  details: AtraafStop[];
  slots?: AtraafSlotPayload[];
}

export type TransportType = {
  publicId: number;
  travelTypeName: string;
};

export type UpdateAtraafStatusPayload = {
  publicId: string;
  isActive: boolean;
};